export default "__VITE_ASSET__a9364efa__"